import apiCall from "./apiCall";
export default async function postCategory(URLEND, BODY) {
    const URL = process.env.REACT_APP_API_URL+'/api/'+process.env.REACT_APP_API_VERSION+'/'+URLEND;
    const data = await apiCall('POST', URL, BODY);
    return data;
};